import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActionWithConfirmationTextComponent, ConfirmationData } from "../action-with-confirmation-text/action-with-confirmation-text.component";

@Component({
    selector: "app-action-delete",
    templateUrl: "../action-with-confirmation-text/action-with-confirmation-text.component.html",
    styleUrls: ["../action-with-confirmation-text/action-with-confirmation-text.component.scss"],
})
export class ActionDeleteComponent extends ActionWithConfirmationTextComponent {
    constructor(
        public override dialogRef: MatDialogRef<ActionDeleteComponent>,
        @Inject(MAT_DIALOG_DATA) public override data: ConfirmationData,
    ) {
        super(dialogRef, data);
        this.title = "Delete";
        this.confirmationAction = "deletion";
        this.disclaimer = "* Changes will be applied immediately and be reflected in Zenity within 24h";
    }
}
